import '@/assets/sass/now-ui-kit.scss';
import '@/assets/sass/demo.scss';
import globalDirectives from './globalDirectives';
import globalMixins from './globalMixins';
import globalComponents from './globalComponents';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
import VueLazyload from 'vue-lazyload'
// import VueParticles from 'vue-particles'


locale.use(lang);

export default {
    install(Vue) {
        Vue.use(globalDirectives);
        Vue.use(globalMixins);
        Vue.use(globalComponents);
        // Vue.use(VueParticles);
        Vue.use(VueLazyload, {
          // preLoad: .3,
          observer: true,
          // optional
          observerOptions: {
            rootMargin: '700px',
            threshold: 0
          }
        });
    }
}
